import { generateChatResponse } from "@/lib/db/queries"

export const myProvider = {
  languageModel(modelId?: string) {
    return {
      async generateText({ prompt }: { prompt: string }) {
        const res = await generateChatResponse({
          chatId: "ad-hoc",
	  model: modelId || "chat-model",
          messages: [{ role: "user", content: prompt }],
        })
        return res
      },
    }
  },
}
